export default class Controller {
  constructor(modules) {
    this.modules = modules;

    window.addEventListener('find-controllers', (event) => {
      const { parent } = event.detail;
      this.findControllers(parent);
    });
  }

  findControllers({parent}) {
    const nodes = parent.querySelectorAll('[data-controller]');

    nodes.forEach((node) => {
      const controllers = node.getAttribute('data-controller').split(',');

      controllers.forEach((controller) => {
        controller = controller.trim();
        this.init(controller, node);
      });
    });
  }

  init(controller, node) {
    if (!node[controller]) {
      if (!this.modules[controller]) {
        console.log(`${controller} not found`);
        return;
      }

      node[controller] = new this.modules[controller]();
      node[controller].node = node;
      node[controller].data = Object.assign({}, node.dataset);

      const outlets = {};

      node.querySelectorAll('[data-outlet-group]').forEach((outletGroup) => {
        if (outletGroup.closest(`[data-controller="${controller}"]`) !== node) {
          return;
        }

        const groupOutlets = {
          node: outletGroup
        };

        outletGroup.querySelectorAll('[data-outlet]').forEach((outlet) => {
          const key = outlet.dataset.outlet;

          if (key.startsWith('[') && key.endsWith(']')) {
            key = key.slice(1, -1);

            if (!groupOutlets[key]) {
              groupOutlets[key] = [];
            }

            groupOutlets[key].push(outlet);
          } else {
            groupOutlets[key] = outlet;
          }
        });

        let groupKey = outletGroup.dataset.outletGroup;

        if (groupKey.startsWith('[') && groupKey.endsWith(']')) {
          groupKey = groupKey.slice(1, -1);

          if (!outlets[groupKey]) {
            outlets[groupKey] = [];
          }

          outlets[groupKey].push(groupOutlets);
        } else {
          outlets[groupKey] = groupOutlets;
        }
      });

      node.querySelectorAll('[data-outlet]').forEach((outlet) => {
        if (outlet.closest(`[data-controller="${controller}"]`) !== node) {
          return;
        }

        if (outlet.closest('[data-outlet-group]')) {
          return;
        }

        let key = outlet.dataset.outlet;

        if (key.startsWith('[') && key.endsWith(']')) {
          key = key.slice(1, -1);

          if (!outlets[key]) {
            outlets[key] = [];
          }

          outlets[key].push(outlet);
        } else {
          outlets[key] = outlet;
        }
      });

      node[controller].outlets = outlets;

      try {
        node[controller].init();
      } catch (e) {
        console.dir(e);
      }
    }
  }
}
